import organizer1 from "../../../assets/svg/organizer1.svg";
import rect18 from "../../../assets/svg/Rectangle 18.svg";
import rect19 from "../../../assets/svg/Rectangle 19.svg";
import rect20 from "../../../assets/svg/Rectangle 20.svg";
import plat1 from "../../../assets/svg/plat1.svg";
import plat2 from "../../../assets/svg/plat2.svg";
import plat3 from "../../../assets/svg/plat3.svg";
import plat4 from "../../../assets/svg/plat4.png";
import svg184 from "../../../assets/svg/svg184.svg";
import svg186 from "../../../assets/svg/svg186.svg";
import svg187 from "../../../assets/svg/svg187.svg";
import svg188 from "../../../assets/svg/svg188.svg";
import svg189 from "../../../assets/svg/svg189.svg";
import img12 from "../../../assets/img/img12.png";

import svg193 from "../../../assets/svg/svg193.svg";
import svg194 from "../../../assets/svg/svg194.svg";

// MSME images
import msmeHero from "../../../assets/img/msme/9b948f51583d9621d3d987b02d690a75 1.svg";
import msmeRect18 from "../../../assets/img/msme/Rectangle 18.png";
import msmeRect19 from "../../../assets/img/msme/Rectangle 19.png";
import msmeRect20 from "../../../assets/img/msme/Rectangle 20.png";
import msmeStruggles from "../../../assets/img/msme/ChatGPT Image Nov 5, 2025, 08_29_14 AM 1.png";
import msmeGroup from "../../../assets/img/msme/Group 1000001644.png";
import msmeIcon1 from "../../../assets/img/msme/3D vector mesh paper bill of transaction receipt payment icon_ Cut paid check and financ 1.svg";
import msmeIcon2 from "../../../assets/img/msme/Mobile Wallet Pictures _ Freepik 2.svg";
import msmeIcon3 from "../../../assets/img/msme/ccfd9013f33a45d95aceb89023a5de2a 1.svg";
import msmePlaeholder from "../../../assets/img/msme/placeholder.png";

// Enterprise images
import enterpriseHero from "../../../assets/img/enterprises/placeholder.png";
import enterpriseRect18 from "../../../assets/img/enterprises/Rectangle 18.png";
import enterpriseRect19 from "../../../assets/img/enterprises/Rectangle 19.png";
import enterpriseRect20 from "../../../assets/img/enterprises/Rectangle 20.png";
import enterpriseStruggles from "../../../assets/img/enterprises/ChatGPT Image Nov 5, 2025, 08_29_14 AM 1.png";
import enterpriseGroup from "../../../assets/img/enterprises/Group 1000001644.png";

// Contractor images
import contractorHero from "../../../assets/img/contractor/portrait-professional-young-black-woman-civil-engineer-architecture-worker-wearing-hard-hat-safety-working-construction-site-warehouseusing-laptop-work 1.png";
import contractorRect18 from "../../../assets/img/contractor/Rectangle 18.png";
import contractorRect19 from "../../../assets/img/contractor/Rectangle 19.png";
import contractorRect20 from "../../../assets/img/contractor/Rectangle 20.png";
import contractorStruggles from "../../../assets/img/contractor/ChatGPT Image Nov 5, 2025, 08_29_14 AM 1.png";
import contractorGroup from "../../../assets/img/contractor/placeholder.png";
import contractorIcon1 from "../../../assets/img/contractor/Handyman Holding Multiple Tools Stock Vector - Illustration of mascot, plank_ 64013629 1.svg";
import contractorIcon2 from "../../../assets/img/contractor/Tipper Dump Truck Lorry, Dump Truck, Dump, Truck PNG Transparent Image and Clipart for Free Download 1.svg";
import contractorIcon3 from "../../../assets/img/contractor/3d Set Of Construction Materials And Tools Materials For Construction 3d Illustration, Construction, 3d, Tool PNG Transparent Image and Clipart for Free Download 1.svg";
import contractorIcon4 from "../../../assets/img/contractor/Container shipping to Pakistan from the UK 1.svg";

const baseConfig = {
  hero: {
    titleBold: "Manage All Your Event",
    titleLight: "Payments Effortlessly and in Real Time",
    desc: "Handle staff, vendors, and logistics from one secure dashboard. Ndovu Pay makes event payments fast, transparent, and hassle-free.",
    img: organizer1,
  },
  platform: {
    images: [rect18, rect19, rect20],
    icons: [plat1, plat2, plat3, plat4],
    title: "One Smart Platform",
    desc: "Manage every payment, from ticketing and staffing to vendor and logistics settlements.",
  },
  struggles: {
    title: "The Everyday Payment Struggles You Shouldn't Have to Deal With",
    items: [
      "Managing hundreds of temporary staff payments",
      "Vendor disputes from delayed or missing payments",
      "Manual reconciliations and paperwork after events",
      "Managing airtime and allowances for field teams",
      "Limited visibility over paid and unpaid suppliers",
    ],
    img: svg184,
  },
  why: {
    title: "Why Organizers Love Ndovu Pay",
    features: [
      {
        icon: svg186,
        title: "Automate Payments from One Place",
        desc: "Manage all staff, vendor, and supplier payments from a single, unified platform no more juggling accounts or apps.",
      },
      {
        icon: svg188,
        title: "Full Auditability for Sponsors & Management",
        desc: "Give stakeholders complete visibility with detailed, downloadable reports showing where every shilling went.",
      },
      {
        icon: svg187,
        title: "Reduce Reconciliation Time from Days to Minutes",
        desc: "Generate instant summaries and reports that match every payment made, saving hours of manual work after each event.",
      },
      {
        icon: svg189,
        title: "Keep Every Transaction Traceable & Transparent",
        desc: "Track every payout, approval, and confirmation in real time—ensuring full accountability and trust across your event operations.",
      },
    ],
    img: img12,
  },
  how: {
    title: "How Ndovu Pay Makes Event Payments Effortless",
    subtitle: "Automate, track, and pay without the chaos.",
    steps: [
      {
        number: "1",
        title: "Bulk Payments via M-Pesa, Airtel, or Bank",
        desc: "Send hundreds of payments at once fast, secure, and directly to your team or vendors' mobile wallets or bank accounts.",

        mt: "9rem",
      },
      {
        number: "2",
        title: "Petty Cash Module with Digital Requests & Approvals",
        desc: "Manage small event expenses digitally with built-in request, approval, and tracking features no more paper or lost receipts.",
        mt: "-4rem",
      },
      {
        number: "3",
        title: "Vendor Settlements with Real-Time Proof of Payment",
        desc: "Pay your suppliers instantly and share automatic payment confirmations to avoid disputes or follow-ups.",
        mt: "-17rem",
      },
      {
        number: "4",
        title: "Airtime & Data Distribution for Connected Teams",
        desc: "Distribute airtime or data bundles to field teams instantly, ensuring everyone stays connected during events.",

        mt: "10rem",
      },
      {
        number: "5",
        title: "Financial Reports per Event for Audits & Budgeting",
        desc: "Get detailed, exportable reports showing all event expenses, payments, and balances—perfect for sponsor reporting or audits.",
        mt: "-1rem",
      },
      {
        number: "6",

        title: "Event Ticketing",
        desc: "Simplify ticket sales and collections with integrated digital ticketing and instant reconciliation after your event.",

        mt: "-14rem",
      },
    ],
  },
};

export const eventOrganizersConfig = { ...baseConfig };

export const contractorsConfig = {
  hero: {
    titleBold: "Simplify Project & Contractor",
    titleLight: "Payments Anywhere",
    desc: "Manage multiple projects, suppliers, and field teams with ease. Ndovu Pay automates disbursements, tracks budgets, and keeps every payment accountable.",
    img: contractorHero,
  },
  platform: {
    images: [contractorRect18, contractorRect19, contractorRect20],
    icons: [contractorIcon1, contractorIcon2, contractorIcon3, contractorIcon4],
    title: "One Smart Platform",
    desc: "Automate project payouts, manage suppliers, and track field expenses in real time—all in one place with Ndovu Pay.",
  },
  struggles: {
    title: "The Hidden Hassles of Managing Project Payments",
    items: [
      "Cash-based payments to field workers",
      "Manual reconciliation between field teams and HQ",
      "Inconsistent wage disbursements",
      "Limited visibility into project-level spending",
    ],
    img: contractorStruggles,
  },
  why: {
    title: "Payments Made Simple for Contractors",
    features: [
      {
        icon: svg186,
        title: "Zero Manual Cash Handling",
        desc: "Eliminate cash risks on-site with secure digital payments straight to workers and suppliers.",
      },
      {
        icon: svg188,
        title: "Faster Supplier and Worker Payments",
        desc: "Send bulk payments instantly through mobile money or bank transfers no delays or paperwork.",
      },
      {
        icon: svg187,
        title: "Transparency in All Disbursements",
        desc: "Track every payment in real time for clear, accountable project finances.",
      },
      {
        icon: svg193,
        title: "Centralised Project Finance Control",
        desc: "Manage budgets, approvals, and reports for all projects from one dashboard.",
      },
    ],
    img: contractorGroup,
  },
  how: {
    title: "Simplify Every Payment Across Your Projects",
    subtitle:
      "Automate field disbursements, manage budgets, and track every shilling all from one dashboard.",
    steps: [
      {
        number: "1",
        title: "Bulk Worker Payments through Mobile or Bank",
        desc: "Disburse wages to all site workers instantly via M-Pesa, Airtel, or bank transfer—no need for cash handling.",

        mt: "9rem",
      },
      {
        number: "2",
        title: "Wallet Management per Project or Department",
        desc: "Allocate and track funds separately for each project, site, or department to maintain full budget control.",
        mt: "-4rem",
      },
      {
        number: "3",
        title: "Digital Petty Cash Requests with Approval Workflow",
        desc: "Handle small on-site expenses digitally with easy request, approval, and tracking tools.",
        mt: "-17rem",
      },
      {
        number: "4",
        title: "Supplier Settlements and Invoice Tracking",
        desc: "Pay suppliers directly, track invoices, and share proof of payment in real time to prevent delays or disputes.",

        mt: "10rem",
      },
      {
        number: "5",
        title: "Real-Time Reporting for All Projects",
        desc: "Get instant visibility into project expenses and cash flow across all locations for better financial oversight.",
        mt: "-1rem",
      },
      {
        number: "6",
        title: "Airtime & Data for Field Teams",
        desc: "Keep crews connected by distributing airtime and data bundles directly from the platform.",
        mt: "-14rem",
      },
    ],
  },
};

export const msmesConfig = {
  hero: {
    titleBold: "Powering Africa's Micro and Small Businesses",
    titleLight: "with Financial Simplicity",
    desc: "MSMEs keep Africa moving. Ndovu Pay helps them manage payments, track expenses, and stay in control.",
    img: msmeGroup,
  },
  platform: {
    images: [msmeRect18, msmeRect19, msmeRect20],
    icons: [msmeIcon1, msmeHero, msmeIcon2, msmeIcon3],
    title: "One Smart Platform",
    desc: "Ndovu Pay helps Africa's MSMEs with simple tools to automate payments, control costs, and maintain financial transparency.",
  },
  struggles: {
    title: "What's Holding Your Business Back?",
    items: [
      "Manual payrolls and cash disbursements",
      "Time-consuming reconciliations",
      "Limited visibility on expenses",
      "Use of multiple unlicensed payment tools",
    ],
    img: msmeStruggles,
  },
  why: {
    title: "Payments Made Simple for MSMEs",
    features: [
      {
        icon: svg186,
        title: "Save Administrative Time and Cost",
        desc: "Automate repetitive financial tasks so your team can focus on growth, not paperwork.",
      },
      {
        icon: svg188,
        title: "Gain Complete Visibility and Control",
        desc: "Monitor every transaction in real time  across teams, projects, and payment channels.",
      },
      {
        icon: svg194,
        title: "Improve Credibility and Trust with Suppliers",
        desc: "Track every payment in real time for clear, accountable project finances.",
      },
      {
        icon: svg187,
        title: "Simplify Compliance and Tax Reporting",
        desc: "Manage budgets, approvals, and reports for all projects from one dashboard.",
      },
    ],
    img: msmePlaeholder,
  },
  how: {
    title: "Simplify Every Payment Across Your Projects",
    subtitle:
      "Automate field disbursements, manage budgets, and track every shilling all from one dashboard.",
    steps: [
      {
        number: "1",
        title: "Unified Dashboard for All Payments",
        desc: "View and control all your payment activity — payroll, suppliers, petty cash — from one simple dashboard.",

        mt: "9rem",
      },
      {
        number: "2",
        title: "Automated Petty Cash Approvals & Tracking",
        desc: "Digitise small business expenses with built-in request, approval, and tracking — no paper, no lost receipts.",
        mt: "-4rem",
      },
      {
        number: "3",
        title: "Bulk Employee & Vendor Payments",
        desc: "Pay your entire team and all suppliers at once via M-Pesa, Airtel, or bank — fast, secure, and fully traceable.",

        mt: "-17rem",
      },
      {
        number: "4",
        title: "Wallet System by Project or Client",
        desc: "Allocate budgets per project or client and track spending separately for better financial control.",
        mt: "10rem",
      },
      {
        number: "5",
        title: "Daily and Monthly Cash-Flow Reports",
        desc: "Get automated daily and monthly summaries of all inflows and outflows to stay on top of your business finances.",
        mt: "-1rem",
      },
    ],
  },
};

export const enterprisesConfig = {
  hero: {
    titleBold: "Powering Enterprise Financial Operations with",
    titleLight: "Control, Clarity, and Confidence",
    desc: "For organizations with complex finances, Ndovu Pay brings all payments, approvals, and reports into one secure, scalable system.",
    img: enterpriseGroup,
  },
  platform: {
    images: [enterpriseRect18, enterpriseRect19, enterpriseRect20],
    icons: [msmeIcon1, msmeIcon2, msmeIcon3],
    title: "One Smart Platform",
    desc: "Ndovu Pay streamlines financial operations for large organizations, NGOs, and government bodies — ensuring speed, compliance, and accountability.",
  },
  struggles: {
    title: "Where Financial Complexity Slows You Down",
    items: [
      "Multiple disparate systems for payroll, suppliers & project disbursements",
      "Difficulty maintaining compliance & reporting accuracy",
      "Long approval chains causing delayed payments",
      "Manual reconciliations prone to errors and audit issues",
    ],
    img: enterpriseStruggles,
  },
  why: {
    title: "Payments Made Simple for Enterprises",
    features: [
      {
        icon: svg186,
        title: "Faster Approvals and Payment Turnaround Times",
        desc: "Automate repetitive financial tasks so your team can focus on growth, not paperwork.",
      },
      {
        icon: svg188,
        title: "Complete Financial Visibility Across the Organisation",
        desc: "Monitor budgets, disbursements, and payments in real time from one dashboard.",
      },
      {
        icon: svg187,
        title: "Reduced administrative and reconciliation overheads",
        desc: "Track every payment in real time for clear, accountable project finances.",
      },
      {
        icon: svg189,
        title: "Strengthened audit readiness & regulatory compliance",
        desc: "Maintain detailed records and reports for effortless audits and donor reviews.",
      },
    ],
    img: enterpriseHero,
  },
  how: {
    title: "Simplify Every Payment Across Your Projects",
    subtitle:
      "Automate disbursements, manage budgets, and track every shilling all from one dashboard.",
    steps: [
      {
        number: "1",
        title: "Unified Financial Control",
        desc: "Manage payroll, suppliers, and project disbursements from one centralised platform — no more disparate systems.",
        mt: "9rem",
      },
      {
        number: "2",
        title: "Multi-Level Approvals",
        desc: "Customizable workflows for department heads, finance teams, and executives",
        mt: "-4rem",
      },
      {
        number: "3",
        title: "Departmental Wallets",
        desc: "Pay workers and suppliers instantly, whether in the field or at the office.",
        mt: "-17rem",
      },
      {
        number: "4",
        title: "Bulk Payments",
        desc: "Disburse funds instantly to M-Pesa, Airtel, or bank accounts",
        mt: "10rem",
      },
      {
        number: "5",
        title: "Advanced Analytics",
        desc: "Real-time dashboards for spend tracking, variance analysis, and compliance reports",
        mt: "-1rem",
      },
    ],
  },
};
